/**
 * Oucheng analytics and CTA event model.
 * Development-theme previews write to window.__ouchengPreviewEvents and never call gtag.
 *
 * Ads contract (do not change): WhatsApp click emits cta_click + whatsapp_click.
 * Google Ads Primary stays whatsapp_click. This file must NOT emit generate_lead
 * or a gtag Ads conversion on WhatsApp. lead_intent is analysis-only.
 */
(function () {
  'use strict';

  var MAX_WAIT_MS = 5000;
  var POLL_MS = 80;
  var previewMode = Boolean(window.ga_preview_mode) || /(?:[?&](?:preview_theme_id|preview_key)=)|localhost|127\.0\.0\.1/i.test(window.location.href);

  function s(value) {
    return value === undefined || value === null ? '' : String(value).trim();
  }

  function waitForGtag(callback) {
    var elapsed = 0;
    function check() {
      if (typeof window.gtag === 'function') {
        callback();
        return;
      }
      elapsed += POLL_MS;
      if (elapsed >= MAX_WAIT_MS) {
        if (window.console && console.warn) console.warn('Oucheng analytics: gtag unavailable; production event skipped.');
        return;
      }
      window.setTimeout(check, POLL_MS);
    }
    check();
  }

  function inferPageType(pathname) {
    var path = s(pathname || window.location.pathname || '/').toLowerCase();
    if (path === '/' || path === '') return 'home';
    if (path.indexOf('/collections/') === 0) return 'collection';
    if (path.indexOf('/pages/contact') === 0 || path === '/contact') return 'contact';
    if (path.indexOf('/pages/') === 0) return 'landing_page';
    if (path.indexOf('/blogs/') === 0) return 'blog';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/search') === 0) return 'search';
    return 'other';
  }

  function closestData(name, element) {
    try {
      var node = element && element.closest ? element.closest('[data-' + name + ']') : document.querySelector('[data-' + name + ']');
      return node ? s(node.getAttribute('data-' + name)) : '';
    } catch (error) {
      return '';
    }
  }

  function readUtmFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      utm_term: params.get('utm_term') || ''
    };
  }

  function getUtmParams() {
    if (window.ga_utm && window.ga_utm.utm_source) return window.ga_utm;
    var current = readUtmFromUrl();
    try {
      if (current.utm_source && window.sessionStorage) {
        sessionStorage.setItem('oucheng_utm', JSON.stringify(current));
      } else if (window.sessionStorage) {
        var stored = sessionStorage.getItem('oucheng_utm');
        if (stored) current = JSON.parse(stored);
      }
    } catch (error) {}
    window.ga_utm = current;
    return current;
  }

  function baseParams(element) {
    var params = {
      page_location: window.location.href,
      page_referrer: document.referrer || '',
      page_title: document.title || '',
      page_type: inferPageType(window.location.pathname),
      cluster_name: closestData('cluster', element),
      solution_slug: closestData('solution-slug', element),
      region: closestData('region', element),
      language: closestData('language', element) || s(window.ga_language)
    };
    if (window.ga_country) params.country = s(window.ga_country);

    var utm = getUtmParams();
    Object.keys(utm).forEach(function (key) {
      if (utm[key]) params[key] = utm[key];
    });
    return params;
  }

  function fire(eventName, params) {
    if (previewMode) {
      window.__ouchengPreviewEvents = window.__ouchengPreviewEvents || [];
      var previewEvent = { event: eventName, params: params || {}, timestamp: new Date().toISOString() };
      window.__ouchengPreviewEvents.push(previewEvent);
      if (window.console && console.info) console.info('[Oucheng preview event]', previewEvent);
      return;
    }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, params || {});
    } catch (error) {
      if (window.console && console.error) console.error('Oucheng analytics event error:', error);
    }
  }

  function isWhatsAppLink(href) {
    var url = s(href).toLowerCase();
    return url.indexOf('wa.me/') !== -1 || url.indexOf('api.whatsapp.com') !== -1 || url.indexOf('whatsapp.com') !== -1 || url.indexOf('whatsapp://') === 0;
  }

  function isEmailLink(href) {
    return s(href).toLowerCase().indexOf('mailto:') === 0;
  }

  function isPhoneLink(href) {
    var url = s(href).toLowerCase();
    return url.indexOf('tel:') === 0 || url.indexOf('sms:') === 0 || url.indexOf('smsto:') === 0;
  }

  function isContactRouteLink(href) {
    if (!href) return false;
    try {
      var parsed = new URL(href, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      var path = parsed.pathname.toLowerCase().replace(/\/+$/, '');
      return path === '/pages/contact' || path === '/pages/contact-us' || path === '/contact';
    } catch (error) {
      var h = s(href).toLowerCase().replace(/\/+$/, '');
      return h === '/pages/contact' || h === '/pages/contact-us' || h === '/contact';
    }
  }

  function humanize(value, fallback) {
    value = s(value);
    return value ? value.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ') : fallback;
  }

  function buildWhatsAppMessage(link) {
    var explicit = s(link.getAttribute('data-whatsapp-message'));
    if (explicit) return explicit;
    var solution = humanize(closestData('solution-slug', link), 'your production solution');
    var region = humanize(closestData('region', link), 'my market');
    var canonicalPath = s(link.getAttribute('data-canonical-path'));
    var canonical = document.querySelector('link[rel="canonical"]');
    var pageUrl = canonicalPath ? new URL(canonicalPath, window.location.origin).href : (canonical ? canonical.href : window.location.href);
    var utm = getUtmParams();
    var campaign = utm.utm_campaign || [utm.utm_source, utm.utm_medium].filter(Boolean).join(' / ') || 'direct';
    return 'Hi Oucheng, I’m interested in ' + solution + ' for ' + region + '. Page: ' + pageUrl + '. Campaign: ' + campaign + '. My target product/output is: ____';
  }

  function enrichWhatsAppHref(link) {
    if (!link) return '';
    var href = s(link.getAttribute('href') || link.href);
    if (!isWhatsAppLink(href)) return href;
    try {
      var url = new URL(href, window.location.origin);
      url.searchParams.set('text', buildWhatsAppMessage(link));
      link.href = url.href;
      return url.href;
    } catch (error) {
      return href;
    }
  }

  function normalizeWhatsAppLinkUrl(href) {
    var original = s(href);
    try {
      var url = new URL(original, window.location.origin);
      var protocol = url.protocol.toLowerCase();
      var host = url.hostname.toLowerCase().replace(/^www\./, '');
      var phone = s(url.searchParams.get('phone')).replace(/\D/g, '');

      if (protocol === 'whatsapp:') return phone ? 'https://wa.me/' + phone : 'whatsapp://send';
      if (host === 'wa.me') return 'https://wa.me' + url.pathname.replace(/\/+$/, '');
      if (host === 'api.whatsapp.com' || host === 'whatsapp.com') {
        return phone ? 'https://wa.me/' + phone : url.origin + url.pathname.replace(/\/+$/, '');
      }
    } catch (error) {}
    return original.split(/[?#]/)[0];
  }

  function inferPosition(element) {
    if (!element || !element.closest) return 'inline';
    if (element.closest('.solution-preview__mobile-cta')) return 'mobile_sticky';
    if (element.closest('.solution-preview__hero')) return 'hero';
    if (element.closest('.solution-preview__cta')) return 'final';
    if (element.closest('.mobile-navigation-bar, .mobile-nav-whatsapp')) return 'mobile_menu';
    if (element.closest('header')) return 'header';
    if (element.closest('footer')) return 'footer';
    if (element.closest('.floating-contact-sidebar')) return 'floating_sidebar';
    return 'inline';
  }

  function labelFor(element, fallback) {
    return s(element.getAttribute('data-cta-label')) || s(element.textContent).replace(/\s+/g, ' ') || fallback;
  }

  var lastSignature = '';
  var lastTimestamp = 0;
  function isDuplicate(signature) {
    var now = Date.now();
    if (signature === lastSignature && now - lastTimestamp < 1000) return true;
    lastSignature = signature;
    lastTimestamp = now;
    return false;
  }

  function sendCta(eventName, channel, position, label, href, element) {
    var params = baseParams(element);
    params.cta_channel = channel;
    params.cta_position = position;
    params.cta_label = label;
    params.link_url = href;
    fire(eventName, params);
  }

  function markOnce(key) {
    if (!key) return true;
    try {
      if (window.sessionStorage && window.sessionStorage.getItem(key)) return false;
      if (window.sessionStorage) window.sessionStorage.setItem(key, '1');
      return true;
    } catch (error) {
      return true;
    }
  }

  function sendLeadIntent(intentType, element, extras) {
    extras = extras || {};
    var params = baseParams(element);
    params.intent_type = intentType || 'lead_intent';
    params.cta_channel = extras.cta_channel || 'behavior';
    params.cta_position = extras.cta_position || inferPosition(element);
    params.cta_label = extras.cta_label || params.intent_type;
    params.event_category = 'b2b_lead_funnel';
    params.lead_stage = 'intent';
    params.lead_source = extras.lead_source || params.cta_channel || 'website';
    params.source_platform = 'shopify_theme';
    if (extras.link_url) params.link_url = extras.link_url;
    var key = [
      'oc_ga4_lead_intent',
      params.intent_type,
      (window.location.pathname || '').toLowerCase(),
      params.cta_channel,
      params.cta_position
    ].join('|');
    if (!markOnce(key)) return false;
    fire('lead_intent', params);
    return params;
  }

  function sendLeadFunnelEvent(eventName, params) {
    var allowed = {
      lead_intent: true,
      generate_lead: true,
      qualify_lead: true,
      close_convert_lead: true
    };
    if (!allowed[eventName]) return false;
    var payload = Object.assign(baseParams(null), params || {});
    payload.event_category = payload.event_category || 'b2b_lead_funnel';
    payload.source_platform = payload.source_platform || 'shopify_theme';
    fire(eventName, payload);
    return payload;
  }

  function detectContactFormSuccess() {
    try {
      var form = document.querySelector('form[action*="/contact"] p.success');
      if (!form) return;
      var key = 'oucheng_lead_' + window.location.pathname + window.location.search;
      if (window.sessionStorage && sessionStorage.getItem(key)) return;
      if (window.sessionStorage) sessionStorage.setItem(key, '1');
      sendCta('generate_lead', 'form', 'contact_form', 'contact_success', window.location.href, form.closest('form'));
    } catch (error) {}
  }

  function isLeadIntentPage() {
    var pageType = inferPageType(window.location.pathname);
    return pageType === 'product' ||
      pageType === 'collection' ||
      pageType === 'landing_page' ||
      pageType === 'contact';
  }

  function scheduleEngagedLeadIntent() {
    if (!isLeadIntentPage()) return;
    var visibleMs = 0;
    var lastVisibleTs = Date.now();
    var fired = false;

    function updateVisibleTime() {
      var now = Date.now();
      if (document.visibilityState !== 'hidden') visibleMs += now - lastVisibleTs;
      lastVisibleTs = now;
    }

    function check() {
      if (fired) return;
      updateVisibleTime();
      if (visibleMs >= 60000) {
        fired = true;
        sendLeadIntent('engaged_60s', null, {
          cta_channel: 'engagement',
          cta_position: inferPageType(window.location.pathname),
          cta_label: 'engaged_60s'
        });
        return;
      }
      window.setTimeout(check, 5000);
    }

    document.addEventListener('visibilitychange', updateVisibleTime);
    window.setTimeout(check, 5000);
  }

  function startTracking() {
    fire('page_view', baseParams(null));
    detectContactFormSuccess();
    scheduleEngagedLeadIntent();
  }

  function initialize() {
    window.inferPageType = inferPageType;
    window.getClusterName = function () { return closestData('cluster', null); };
    window.sendLeadIntentEvent = function (intentType, params) {
      return sendLeadIntent(intentType, null, params || {});
    };
    window.sendB2BLeadEvent = sendLeadFunnelEvent;
    window.sendQualifyLeadEvent = function (params) {
      return sendLeadFunnelEvent('qualify_lead', params || {});
    };
    window.sendCloseConvertLeadEvent = function (params) {
      return sendLeadFunnelEvent('close_convert_lead', params || {});
    };

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var link = target.closest('a');
      var cta = target.closest('.js-cta');
      if (!link && !cta) return;
      var element = cta || link;
      var href = link ? s(link.getAttribute('href') || link.href) : '';
      var position = s(element.getAttribute('data-cta-position')) || inferPosition(element);
      var label = labelFor(element, 'cta_click');
      var channel = s(element.getAttribute('data-cta-channel')) || 'internal';

      if (link && isWhatsAppLink(href)) {
        var analyticsHref = normalizeWhatsAppLinkUrl(href);
        enrichWhatsAppHref(link);
        var waSignature = 'whatsapp|' + analyticsHref + '|' + position;
        if (!isDuplicate(waSignature)) {
          sendCta('cta_click', 'whatsapp', position, label, analyticsHref, element);
          sendCta('whatsapp_click', 'whatsapp', position, label, analyticsHref, element);
          sendLeadIntent('direct_contact_click', element, {
            cta_channel: 'whatsapp',
            cta_position: position,
            cta_label: label,
            link_url: analyticsHref
          });
        }
        return;
      }

      if (link && isContactRouteLink(href)) {
        var contactSignature = 'contact|' + href + '|' + position;
        if (!isDuplicate(contactSignature)) {
          sendLeadIntent('contact_route_click', element, {
            cta_channel: 'contact_page',
            cta_position: position,
            cta_label: label,
            link_url: href
          });
          fire('contact_route_click', Object.assign(baseParams(element), {
            cta_channel: 'contact_page',
            cta_position: position,
            cta_label: label,
            link_url: href
          }));
        }
        return;
      }

      if (link && isEmailLink(href)) {
        channel = 'email';
      } else if (link && isPhoneLink(href)) {
        channel = 'phone';
      } else if (!cta) {
        return;
      }

      var eventName = '';
      if (channel === 'email' || channel === 'wechat') eventName = 'cta_click';
      else if (channel === 'phone') eventName = 'tel_click';
      else return;

      var signature = channel + '|' + href + '|' + position + '|' + label;
      if (!isDuplicate(signature)) {
        sendCta(eventName, channel, position, label, href, element);
        if (channel === 'wechat' && !href) {
          sendLeadIntent('wechat_qr_open', element, {
            cta_channel: 'wechat',
            cta_position: position,
            cta_label: label
          });
        } else if (channel === 'email' || channel === 'wechat') {
          sendLeadIntent('direct_contact_click', element, {
            cta_channel: channel,
            cta_position: position,
            cta_label: label,
            link_url: href
          });
        }
      }
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTracking, { once: true });
    else window.setTimeout(startTracking, 0);
  }

  if (previewMode) {
    initialize();
  } else {
    waitForGtag(function () {
      window.gtag('js', new Date());
      window.gtag('config', window.ga_measurement_id || 'G-JDGQJ08MXC', { send_page_view: false });
      initialize();
    });
  }
})();
